import React from 'react';
import { Grid, Button } from 'semantic-ui-react';
import UploadComponent from './UploadComponent';

const UploadCashbackFile = () => {
  return (
    <Grid centered container padded >
      <Grid.Row>
        <Grid.Column width={5} style={{ marginTop: '20vh' }}>
          <span style={{ fontSize: '1.5em', marginBottom: '2em' }} >
            Upload CSV file containing contacts
          </span>
          <UploadComponent />
          <Button primary style={{ marginTop: '2em' }}>
            Upload
          </Button>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

export default UploadCashbackFile;



// WEBPACK FOOTER //
// ./src/Modules/UploadCashBackFile/component.jsx